var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 8.33333V14.8148H2.22222V8.33333H0V14.8148C0 15.8333 1 16.6667 2.22222 16.6667H17.7778C19 16.6667 20 15.8333 20 14.8148V8.33333H17.7778ZM11.1111 8.9537L13.9889 6.56482L15.5556 7.87037L10 12.5L4.44444 7.87037L6.01111 6.56482L8.88889 8.9537V0H11.1111V8.9537Z",
    fill: "#073C7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.958eac3ecdfa7e4919daeccda8c09353.svg";
export { ForwardRef as ReactComponent };